import { useLoadingLegacy } from '@zc-react-admin/hooks';

import { setUserInfo } from '@/features/auth/authStore';
import { router, usePreviousRoute, useRouter } from '@/features/router';
import { AuthService, MeService } from '@/service/api';
import { store } from '@/store';
import { localStg } from '@/utils/storage';

import { initAuthRoutes } from '../router/initRouter';
import { setIsAlreadyPatch } from '../router/routeStore';
import { useCacheTabs } from '../tab/tabHooks';

import { resetAuth as resetAuthAction, setToken } from './authStore';
import { clearAuthStorage } from './shared';

export const getUserInfo = async () => {
  const { data: userInfo } = await MeService.getInfo();
  localStg.set('userInfo', userInfo!);
  store.dispatch(setUserInfo(userInfo!));
};

export function useInitAuth() {
  const { endLoading, loading, startLoading } = useLoadingLegacy();

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const { navigate } = useRouter();

  // const redirectUrl = searchParams.get('redirect');

  async function toLogin(loginFormVo: Entity.Auth.LoginVo, redirect = true) {
    if (loading) return;

    startLoading();
    try {
      const { data: loginData } = await AuthService.login(loginFormVo);
      if (loginData) {
        localStg.set('token', loginData.token);
        // 2. store user info
        dispatch(setToken(loginData.token));
        dispatch(setIsAlreadyPatch(true));
        await initAuthRoutes(router.reactRouter.patchRoutes);
        if (redirect) {
          // if (redirectUrl) {
          //   navigate(redirectUrl);
          // } else {
          //   navigate('/');
          // }
          navigate('/');
        }
        window.$notification?.success({
          message: t('page.login.common.loginSuccess')
        });
      }
    } catch {
      endLoading();
    }
  }

  return {
    loading,
    toLogin
  };
}

export function useResetAuth() {
  const dispatch = useAppDispatch();

  const previousRoute = usePreviousRoute();

  const cacheTabs = useCacheTabs();

  const { navigate, push, resetRoutes } = useRouter();

  function resetAuth() {
    clearAuthStorage();

    dispatch(resetAuthAction());

    resetRoutes();

    cacheTabs();

    // if (!previousRoute?.handle?.constant) {
    if (previousRoute?.fullPath) {
      push('/login', { redirect: previousRoute.fullPath }, null, true);
    } else {
    }
    // }
  }

  return resetAuth;
}
